import {
  Stack,
  Dialog,
  Button,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { ProductRedeemFee } from 'src/type/gold-withdraw';
import { fNumber } from 'src/utils/format-number';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  productRedeemFees: ProductRedeemFee[];
};

export default function ProductRedeemFeeListDialog({ open, onClose, productRedeemFees }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>ข้อมูลการแบ่งน้ำหนักสินค้า</DialogTitle>
      <DialogContent>
        <Stack spacing={2} py={1}>
          {productRedeemFees.length > 0 ? (
            productRedeemFees.map((fee, index) => (
              <Stack
                key={fee.id || index}
                spacing={1}
                sx={{
                  p: 2,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                }}
              >
                <Typography variant="subtitle2" fontWeight="bold">
                  {fee.name}
                </Typography>
                <Stack direction="row" spacing={2}>
                  <Typography variant="body2">
                    <strong>น้ำหนัก (บาท):</strong> {fNumber(fee.weightBaht, 4)} บาท
                  </Typography>
                  <Typography variant="body2">
                    <strong>น้ำหนัก (กรัม):</strong> {fNumber(fee.weightGram, 3)} กรัม
                  </Typography>
                </Stack>
                {fee.description && (
                  <Typography variant="caption" color="text.secondary">
                    {fee.description}
                  </Typography>
                )}
              </Stack>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary" textAlign="center" py={2}>
              ไม่มีข้อมูลการแบ่งน้ำหนักสำหรับสินค้านี้
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
